__turbopack_context__.v({
  "artist": "ArtistCard-module-scss-module__gOSA3a__artist",
  "card": "ArtistCard-module-scss-module__gOSA3a__card",
  "cardDetails": "ArtistCard-module-scss-module__gOSA3a__cardDetails",
  "cardMedia": "ArtistCard-module-scss-module__gOSA3a__cardMedia",
  "description": "ArtistCard-module-scss-module__gOSA3a__description",
  "imageContainer": "ArtistCard-module-scss-module__gOSA3a__imageContainer",
  "meta": "ArtistCard-module-scss-module__gOSA3a__meta",
  "metric": "ArtistCard-module-scss-module__gOSA3a__metric",
  "metricDot": "ArtistCard-module-scss-module__gOSA3a__metricDot",
});
